import React from 'react';
export const PanelPickerContext = React.createContext({});
export const PanelPresetsContext = React.createContext({});
